export const loadApolloAppContent = () =>
  import('./ApolloAppContent').then((m) => ({
    default: m.ApolloAppContent,
  }));

export const preloadApolloAppContent = () => loadApolloAppContent();
